





















































































import { defineComponent } from '@nuxtjs/composition-api'
import CImg from '~/components/shared/configurable/image/CImg.vue'

export default defineComponent({
  components: { CImg },
  setup() {
    const goToTbi = () => {
      window.open('https://www.tbibank.gr', '_blank')
    }

    return {
      goToTbi
    }
  }
})
